import { ICardFootballRanking, CardFootballRanking } from "@sky-it-livedata/livedata-sports-design-system";
import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { DataCardRankingQuery, DataCardRankingSubscription } from "./types";
import transformQuery from "./transformers/query";
import transformSubscription from "./transformers/subscription";
import { graphql } from "appsync";
import { useSubscription } from "../../hooks/useSubscription";
import { queryData } from "./__mocks__/query";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<DataCardRankingQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

const subscriptionDocument = graphql("subscription CardCompetitionRankingSubscription($competitionId: ID!) {\n  onUpdateCardFootballRankingByCompetitionId(competitionId: $competitionId) {\n    competitionId\n    customCompetitionName\n    rankingLink\n    groups {\n      roundName\n      teams {\n        games\n        id\n        logoUrl\n        negativeLogoUrl\n        points\n        position\n        teamName\n        teamUrl\n        trend\n      }\n    }\n  }\n}");

export const getServerProps = ({
  props,
}: WidgetContext<DataCardRankingQuery>): ICardFootballRanking => {
  return transformQuery(props);
}

const CardFootballRankingWidget = ({
  props,
  variables,
  ...rest
}: WidgetContext<ICardFootballRanking>) => {
  log({ props, variables, ...rest });

  transformQuery(queryData); 
  

   const updatedProps = useSubscription<
    ICardFootballRanking,
    DataCardRankingSubscription,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables,
    transform: transformSubscription,
    mergeData: true,
  }) as ICardFootballRanking;

  return (
    <CardFootballRanking {...updatedProps} />
  );
}

export default CardFootballRankingWidget;